import keycloak from '@/utils/keycloak.js'
// 同步更新token到localStorage
export function syncKeycloakToken() {
    if (!keycloak.token) {
        return null
    }

    const bearerToken = `Bearer ${keycloak.token}`
    localStorage.setItem('token', bearerToken)
    return bearerToken
}
// 刷新token
export function updateToken(params) {
    const loginOrigin = localStorage.getItem('loginOrigin')||null;
    if (loginOrigin==='token') return
    const minValidity = params || 60
    keycloak.updateToken(minValidity).then(refreshed => {
        if (refreshed) {
            syncKeycloakToken();
        }
        return refreshed;
    }).catch(error => {
        console.error('token刷新失败', error);
        localStorage.clear();
        keycloak.login()
        return false
    });
}
// 定时刷新
export function setupAutoRefresh() {
    const now = Math.floor(Date.now()/1000)
    const remain = keycloak.tokenParsed.exp - now
    console.log('刷新倒计时',remain-30);
    setInterval(() => {
        updateToken()
    }, remain*1000-30000);
}

